import { Injectable, computed, inject, signal } from '@angular/core';
import {
  CollectionReference,
  DocumentData,
  Firestore,
  QueryConstraint,
  QueryDocumentSnapshot,
  addDoc,
  collection,
  collectionData,
  collectionSnapshots,
  deleteDoc,
  doc,
  getDoc,
  query,
  updateDoc,
  where,
} from '@angular/fire/firestore';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, Subscription, catchError, map, of } from 'rxjs';
import { Patient } from './model';
import { OfficeService } from './office.service';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root',
})
export class PatientsService {
  officeService = inject(OfficeService);
  firestore: Firestore = inject(Firestore);
  router: Router = inject(Router);
  patientList = signal<Patient[]>([]);
  patient = signal<Patient | null>(null);
  patientId = '';

  patientSubscription: Subscription | undefined;

  private logger: LogService = inject(LogService);

  constructor() {
    const params: Record<string, string> = this.collectRouteParams(this.router);
    this.patientId = params['patientId'];
    if (this.patientId) {
      this.getPatient(this.patientId).then(() => {});
    }
    console.log('patientId from ROUTE ' + this.patientId);
    console.log('params from ROUTE ', params);
  }

  // collectionName = 'office/OuTpTO7vsMjnBCPOJbuw/patients';
  collectionName = computed(() => {
    // console.log('PatientsService.collectionName ' + this.officeService.officePath() + '/patients');
    return this.officeService.officePath() + '/patients';
  });
  currentPatientPath = computed(() => {
    const suffix = this.patient()?._documentId ?? this.patientId;
    return this.collectionName() + '/' + suffix;
  });

  getPatients() {
    console.log('getPatients');
    // console.log('PatientsService.collectionName(): ' + this.collectionName());

    if (this.patientSubscription === undefined) {
      console.log('getPatientssub was undefined');
      const patientsCollection = collection(this.firestore, this.collectionName());
      const collectionData$: Observable<QueryDocumentSnapshot<DocumentData, DocumentData>[]> =
        collectionSnapshots(patientsCollection);
      this.patientSubscription = collectionData$
        .pipe(
          map(result => {
            return result.map(snapshot => {
              // console.log('snapshot: ' + snapshot.id, snapshot.data());
              const patient: Patient = { ...(snapshot.data() as Patient), _documentId: snapshot.id };
              return patient;
            });
          }),
          catchError((_error: any) => {
            const error = _error.code;
            console.log('error aaa', { error });
            if (error === 'permission-denied') {
              console.log('loggedout???');
            } else {
              this.logger.error('error in getPatients', { error });
            }
            return of([]);
          })
        )
        .subscribe((result: Patient[]) => {
          console.log('getPatients result', result);
          this.patientList.set(result);
          console.log('[data] patients', { result });
        });
    }
    // const collectionData$: Observable<Patient[]> = collectionData(patientsCollection) as Observable<Patient[]>;
    // collectionData$.subscribe((result: Patient[]) => {
    //   console.log('getPatients2 result', result);
    //   this.patientList.set(result);
    // });
  }

  async getPatient(documentId: string): Promise<Patient> {
    const docRef = doc(this.firestore, this.collectionName(), documentId);
    const snapshot = await getDoc(docRef);
    const patient: Patient = { ...(snapshot.data() as Patient), _documentId: snapshot.id };
    // Feb 2025 -> Kopieren der bisher geltenden uid in das neue name Feld, sofern name leer ist
    if (patient.name === '' || patient.name === undefined || patient.name === null) {
      patient.name = patient.uid;
    }
    this.patient.set(patient);
    console.log('[data] patient', { currentPatientPath: this.currentPatientPath(), patient });
    return patient;
  }

  createPatient(patient: Patient) {
    this.logger.log('createPatient ', patient);
    // const userUid = this.officeService.office()?.author;
    // patient.author = userUid;
    // console.log('PatientsService.collectionName()', this.collectionName());

    return addDoc(collection(this.firestore, this.collectionName()), patient).then(result => {
      // console.log('createPatient result', result);
    });
  }

  updatePatient(patient: Patient) {
    this.logger.log('updatePatient ', patient);
    const { _documentId, ...patientData } = patient;
    const docRef = doc(this.firestore, this.collectionName(), _documentId!);
    return updateDoc(docRef, patientData).then(result => {
      // console.log('updatePatient result', result);
      return result;
    });
  }

  deletePatient(patient: Patient) {
    this.logger.log('deletePatient ', patient);
    const docRef = doc(this.firestore, this.collectionName(), patient._documentId!);
    return deleteDoc(docRef).then(result => {
      // console.log('deletePatient result', result);
    });
  }

  getPatientsByQuery() {
    const userUid = ''; // this.officeService.office()?.author;
    const ref = collection(this.firestore, this.collectionName()) as CollectionReference<unknown>;
    // const qc: QueryConstraint[] = [where('author', '==', userUid), orderBy('name', 'desc'), limit(1)];
    const qc: QueryConstraint[] = [where('author', '==', userUid)];
    // if (startAfterTodo) {
    //   qc.push(startAfter(startAfterTodo.id));
    // }

    collectionData(query(ref, ...qc))
      .pipe(
        map(result => {
          return result.map(item => {
            // console.log('office: ', item);
            const patient: Patient = { ...(item as Patient) };
            return patient;
          });
        })
      )
      .subscribe((result: Patient[]) => {
        // console.log('getPatients result', result);
        this.patientList.set(result);
      });

    // const collectionData$: Observable<Patient[]> = collectionData(patientsCollection) as Observable<Patient[]>;
    // collectionData$.subscribe((result: Patient[]) => {
    //   console.log('getPatients2 result', result);
    //   this.patientList.set(result);
    // });
  }

  private collectRouteParams(router: Router): Record<string, string> {
    let params = {};
    const stack: ActivatedRouteSnapshot[] = [router.routerState.snapshot.root];
    while (stack.length > 0) {
      const route = stack.pop()!;
      params = { ...params, ...route.params };
      stack.push(...route.children);
    }
    return params;
  }
}
